export default {
	home: '首页',
	hosintro: '医院概况',
	departmentnav: '科室导航',
	expertintro: '专家介绍',
	hosdynamic: '医院动态',
	appointment: '预约挂号',
	joinus: '加入我们',
	routenav: '来院导航',
	notice: '医院公告',
	news: '新闻中心',
	media: '媒体聚焦',
	opentender: '招标公告',
	more: '更多',
	msg: '最新资讯',
	ms: '资讯',
	honor: '获得荣誉',
	Process: '取号流程图例',
	job: '招聘职位',
	tomail: '如果您有意向，请投递简历至邮箱',
	friendlink: '友情链接',
	address: '地址',
	tel: '联系方式',
	jobdetail: '查看职位详情',
	position: '职位',
	personnum: '人数',
	edu: '要求学历',
	place: '工作地点',
	salary: '薪资',
	requirements: '工作要求',
	workexperience: '工作经验',
	expert: '专家',
	k: '',
	xzzzqdermyy: '西藏自治区第二人民医院',
	qdndjr: '期待您的加入',
	contactus: '联系我们',
	mail: '邮箱',
	department: '科室',
	professionaltitle: '职称',
	famous: '擅长',
	detailintro: '详细介绍',
	gethonor: '获得荣誉'
}


// WEBPACK FOOTER //
// ./src/utils/zh-CN.js